<template>
  <div>
    <breadcrumbs :data="list_breadcrumbs"></breadcrumbs>
    <div class="section">
      <div class="is-pulled-right">
        <!-- <router-link class="button is-primary" :to="basepath+'sortable'">Sortable</router-link> -->
        <router-link class="button is-success" :to="basepath+'insert'">Insert</router-link>
      </div>
    </div>
    <table class="table is-striped is-fullwidth">
      <thead>
        <tr>
          <th>Title</th>
          <th>Code</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(row_data, index) in list_data" :key="index">
          <td>{{ row_data.title }}</td>
          <td>{{ row_data.code }}</td>
          <td>
            <table-button-dropdown :modul-path="basepath" :row-data="row_data" :btn-detail="false" :btn-show-hide="false" :btn-update="true"
              :btn-delete="true">
              <router-link class="dropdown-item" :to="'/panel/role/menu/' + row_data.id">Role Menu</router-link>
            </table-button-dropdown>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  data () {
    return {
      list_data: [],
      list_breadcrumbs: [{
        title: 'Role',
        path: '/panel/role/'
      }],
      basepath: '/panel/role/'
    }
  },
  created () {
    if (this.getSessionItem('id_token') === null || this.getSessionItem('access_token') === null) {
      this.$router.push('/panel/logout')
    }
    this.getRole()
  },
  mounted () {
    this.$geb.getFilteredBus({
      id: 'delete-data'
    }).subscribe(eventData => {
      this.$geb.emit({id: 'preloader', eventData: true})
      var self = this
      this.flyPostSession('role/delete/', {
        id: eventData.event_data
      })
      .then(function (response) {
        if (response.data.response_code === 1) {
          self.list_data = response.data.data
        } else if (response.data.response_code === -1) {
          self.removeSessionItem('id_token')
          self.removeSessionItem('access_token')
          self.$router.push('/')
        }
        self.$geb.emit({id: 'preloader', eventData: false})
      }).catch(function (response) {
        self.errorMessage(response)
      })
    })

    this.$geb.getFilteredBus({
      id: 'show-hide-data'
    }).subscribe(eventData => {
      this.$geb.emit({id: 'preloader', eventData: true})
      var self = this
      this.flyPostSession('role/show_hide/', {
        id: eventData.id,
        data: eventData.data
      })
      .then(function (response) {
        if (response.data.response_code === 1) {
          alert(response.data.message)
          self.list_data.filter(rowData => rowData.id === eventData.id)[0].show = response.data.data.show
        } else if (response.data.response_code === -1) {
          self.removeSessionItem('id_token')
          self.removeSessionItem('access_token')
          self.$router.push('/')
        }
        self.$geb.emit({id: 'preloader', eventData: false})
      })
      .catch(function (response) {
        self.errorMessage(response)
      })
    })
  },
  methods: {
    getRole () {
      var self = this
      self.$geb.emit({id: 'preloader', eventData: true})
      self.flyGetSession('head/role/get_role')
      .then(function (response) {
        self.$geb.emit({id: 'preloader', eventData: false})
        if (response.data.response_code === 1) {
          self.list_data = response.data.data
        } else if (response.data.response_code === -1) {
          self.removeSessionItem('id_token')
          self.removeSessionItem('access_token')
          self.$router.push('/')
        } else {
          console.log(response.data.message)
        }
      })
      .catch(function (response) {
        self.errorMessage(response)
      })
    }
  }
}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/pages/panel/role/Home.vue